<template>
  <b-modal
    ref="modal"
    :id="modalId"
    :title="title"
    size="md"
    no-close-on-backdrop
    no-close-on-esc
  >
    <div class="form-group">
      <div class="radio-group">
        <b-form-radio
          v-for="option in options"
          :key="option.value"
          v-model="selectedValue"
          :name="radioName"
          :value="option.value"
        >
          {{ option.text }}
        </b-form-radio>
      </div>
    </div>
    <template #modal-footer>
      <b-button variant="secondary" @click="cancel">Cancel</b-button>
      <b-button variant="primary" @click="save">Save</b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
    name: 'UpdateOptionModal',
    props: {
        title: { type: String, required: true },
        options: { type: Array, required: true },
        modalId: { type: String, default: 'updateOptionModal' },
        radioName: { type: String, default: 'updateOption' },
    },
    data() {
        return {
            selectedValue: '',
        }
    },
    methods: {
        forceRerender() {
            this.selectedValue = ''
            this.$refs.modal.show()
        },
        save() {
            this.$emit('save', this.selectedValue)
            this.$refs.modal.hide()
        },
        cancel() {
            this.$refs.modal.hide()
        },
    },
}
</script>

<style scoped>
.radio-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
</style>
